<p-toast></p-toast>

<div class="dispute-review-page dispute-detail-page">
    <div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template pTemplate="start">
                <div class="left-buttons">
                    <h5 class="dispute-toolbar-title" *ngIf="claimNumber">Dispute {{ claimNumber }}</h5>
                    <p-button
                        label="Update Status"
                        icon="pi pi-pencil"
                        class="btn-primary-dispute"
                        [disabled]="!detail"
                        (onClick)="openReviewDrawer()"
                    ></p-button>
                    <p-button
                        *ngIf="canGenerateCreditNote()"
                        label="Generate credit note"
                        icon="pi pi-file-export"
                        severity="secondary"
                        [disabled]="!detail"
                        (onClick)="openCreditNoteDialog()"
                    ></p-button>
                </div>
            </ng-template>
            <ng-template pTemplate="end">
                <div class="right-buttons">
                    <p-button
                        label="Back to Disputes"
                        icon="pi pi-arrow-left"
                        severity="secondary"
                        (onClick)="backToList()"
                    ></p-button>
                </div>
            </ng-template>
        </p-toolbar>
    </div>

    <ng-container *ngIf="detail">
        <app-dispute-summary-header [detail]="detail"></app-dispute-summary-header>

        <div class="detail-body">
            <div class="detail-main">
                <app-dispute-items-card [lines]="detail.lines"></app-dispute-items-card>

                <div class="comment-card" *ngIf="detail.customerComment">
                    <h3 class="dispute-section-title">Customer Comment</h3>
                    <p>{{ detail.customerComment }}</p>
                </div>

                <app-dispute-attachment-card
                    [attachments]="detail.attachments"
                    [lines]="detail.lines"
                    [previewUrls]="attachmentPreviewUrls"
                    (open)="onOpenAttachment($event)"
                    (download)="onDownloadAttachment($event)"
                ></app-dispute-attachment-card>
            </div>

            <aside class="detail-side">
                <app-dispute-timeline [detail]="detail"></app-dispute-timeline>
            </aside>
        </div>
    </ng-container>

    <app-dispute-credit-note-dialog
        [detail]="detail"
        [(visible)]="creditNoteDialogVisible"
        (confirm)="onCreditNoteDialogConfirm($event)"
    ></app-dispute-credit-note-dialog>

    <app-dispute-review-drawer
        [detail]="detail"
        [previewUrls]="attachmentPreviewUrls"
        [drawerOpen]="drawerVisible"
        (visibleChange)="drawerVisible = $event"
        [statusOptions]="drawerStatusOptions()"
        (save)="submitDrawerUpdate($event)"
    ></app-dispute-review-drawer>
</div>
